import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useDispatch } from 'react-redux';
import PassportForm from '../me/PassportForm';
import { Screens } from '../../constants/ScreenNames';
import { updateProfileData } from '../../store/actions/profile';

const PassportModal = ({ navigation, route }) => {
  const { userProfile, countryList } = route.params;
  const dispatch = useDispatch();

  const goBack = (data) => {
    (async () => {
      await dispatch(updateProfileData(data));
      navigation.navigate(Screens.Me);
    })();
  };

  return (
    <View style={styles.body}>
      <PassportForm profile={userProfile} countryList={countryList} onSubmit={goBack} />
    </View>
  );
};

const styles = StyleSheet.create({
  body: {
    flex: 1,
    backgroundColor: 'white',
  },
});

export default PassportModal;
